import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getLinks, createLink, deleteLink } from "../../api/linkApi";
import { uploadImage } from "../../api/imageApi";
import {
  getVideos,
  uploadVideo,
  createExternalVideo,
  deleteVideo,
} from "../../api/videoApi";

const AdminBooksNews = () => {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const [newNews, setNewNews] = useState({
    title: "",
    url: "",
    image: "",
    file: null,
    isExternal: true,
  });

  const [newVideo, setNewVideo] = useState({
    title: "",
    url: "",
    file: null,
    isExternal: true,
  });

  const category = "Books News";
  const navigate = useNavigate();

  const getImageSrc = (imageUrl) => {
    console.log("RAW IMAGE URL FOR DISPLAY:", imageUrl);

    if (!imageUrl) return "/default-placeholder.png";

    if (imageUrl.startsWith("http")) {
      console.log("FINAL IMAGE SRC FOR DISPLAY:", imageUrl);
      return imageUrl;
    }

    const serverUrl = process.env.REACT_APP_API_URL.replace("/api", "");
    const cleanImageUrl = imageUrl.startsWith("/") ? imageUrl : `/${imageUrl}`;
    const finalUrl = `${serverUrl}${cleanImageUrl}`;

    console.log("FINAL IMAGE SRC FOR DISPLAY:", finalUrl);

    return finalUrl;
  };
//   const getImageSrc = (imageUrl) => {
//   if (!imageUrl) return "https://placehold.co/600x400.png";
//   return imageUrl;
// };

  // useEffect(() => {
  //   const fetchNews = async () => {
  //     try {
  //       const links = await getLinks(category);

  //       const sortedLinks = links.sort(
  //         (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
  //       );

  //       setNewsItems([...sortedLinks]);
  //     } catch (error) {
  //       console.error("Error fetching book news:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchNews();
  // }, []);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const [links, videoData] = await Promise.all([
          getLinks(category),
          getVideos(category),
        ]);

        const combinedItems = [
          ...links.map((item) => ({ ...item, itemType: "link" })),
          ...videoData.map((item) => ({ ...item, itemType: "video" })),
        ].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        setNewsItems(combinedItems);
      } catch (error) {
        console.error("Error fetching book news:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  const handleCreate = async () => {
    if (!newNews.title || !newNews.url || (!newNews.image && !newNews.file)) {
      alert("Please add a title, external link, and image.");
      return;
    }

    try {
      let imageUrl = newNews.image;

      if (newNews.file) {
        const formData = new FormData();
        formData.append("image", newNews.file);
        formData.append("title", newNews.title);
        formData.append("category", category);

        const uploadedImage = await uploadImage(formData, category);
        console.log("Uploaded image response:", uploadedImage);

        // imageUrl = uploadedImage.fileUrl;
        imageUrl = uploadedImage.imageUrl || uploadedImage.fileUrl || uploadedImage.url;
        console.log("Final imageUrl being saved:", imageUrl);
      }

      const data = {
        title: newNews.title,
        url: newNews.url,
        imageUrl,
        category,
      };

      console.log("Books News link data being sent:", data);

      const createdItem = await createLink(data);
      console.log("Created Books News item:", createdItem);

      // const updatedNews = [createdItem, ...newsItems];

      // const sortedNews = updatedNews.sort(
      //   (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
      // );

      // setNewsItems(sortedNews);

      const updatedNews = [
        { ...createdItem, itemType: "link" },
        ...newsItems,
      ].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      setNewsItems(updatedNews);

      setNewNews({
        title: "",
        url: "",
        image: "",
        file: null,
        isExternal: true,
      });
    } catch (error) {
      console.error("Error adding book news:", error);
    }
  };

  // const handleDelete = async (id) => {
  //   try {
  //     await deleteLink(id);
  //     setNewsItems(newsItems.filter((item) => item._id !== id));
  //   } catch (error) {
  //     console.error("Error deleting book news:", error);
  //   }
  // };

  const handleDelete = async (item) => {
    try {
      if (item.itemType === "video") {
        await deleteVideo(item._id);
      } else {
        await deleteLink(item._id);
      }

      setNewsItems(newsItems.filter((news) => news._id !== item._id));
    } catch (error) {
      console.error("Error deleting book news item:", error);
    }
  };

  const getVideoSrc = (video) => {
    if (video.fileUrl) {
      const serverUrl = process.env.REACT_APP_API_URL.replace("/api", "");
      return `${serverUrl}${video.fileUrl}`;
    }

    if (video.url?.includes("watch?v=")) {
      return video.url.replace("watch?v=", "embed/");
    }

    return video.url;
  };

  const handleCreateVideo = async () => {
    if (!newVideo.title || (!newVideo.url && !newVideo.file)) {
      alert(
        "Please add a title and either a video URL or uploaded video file.",
      );
      return;
    }

    try {
      let createdVideo;

      if (newVideo.isExternal) {
        createdVideo = await createExternalVideo({
          title: newVideo.title,
          url: newVideo.url,
          category,
        });
      } else {
        const formData = new FormData();
        formData.append("video", newVideo.file);
        formData.append("title", newVideo.title);
        formData.append("category", category);

        createdVideo = await uploadVideo(formData, category);
      }

      const updatedNews = [
        { ...createdVideo, itemType: "video" },
        ...newsItems,
      ].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      setNewsItems(updatedNews);

      setNewVideo({
        title: "",
        url: "",
        file: null,
        isExternal: true,
      });
    } catch (error) {
      console.error("Error adding book news video:", error);
    }
  };

  if (loading) return <p className="p-6">Loading...</p>;

  return (
    <div className="container mx-auto p-6">
      <button
        onClick={() => navigate("/admin")}
        className="bg-gray-300 text-gray-800 px-4 py-2 rounded mb-4 hover:bg-gray-400"
      >
        ← Back to Dashboard
      </button>

      <h1 className="text-3xl font-bold mb-6">Admin - Books News</h1>

      {/* Add News */}
      <div className="mb-6 p-4 border rounded shadow-md">
        <h2 className="text-xl font-semibold mb-4">Add Book News Item</h2>

        <input
          type="text"
          placeholder="Title"
          value={newNews.title || ""}
          onChange={(e) => setNewNews({ ...newNews, title: e.target.value })}
          className="border p-2 w-full mb-2"
        />

        <div className="mb-2">
          <label className="mr-4">
            <input
              type="radio"
              name="imageType"
              checked={newNews.isExternal}
              onChange={() =>
                setNewNews({
                  ...newNews,
                  isExternal: true,
                  file: null,
                })
              }
            />{" "}
            Use Image URL
          </label>

          <label>
            <input
              type="radio"
              name="imageType"
              checked={!newNews.isExternal}
              onChange={() =>
                setNewNews({
                  ...newNews,
                  isExternal: false,
                  image: "",
                })
              }
            />{" "}
            Upload Image
          </label>
        </div>

        {newNews.isExternal ? (
          <input
            type="text"
            placeholder="Image URL"
            value={newNews.image || ""}
            onChange={(e) => setNewNews({ ...newNews, image: e.target.value })}
            className="border p-2 w-full mb-2"
          />
        ) : (
          <input
            type="file"
            accept="image/*"
            onChange={(e) =>
              setNewNews({ ...newNews, file: e.target.files[0] })
            }
            className="border p-2 w-full mb-2"
          />
        )}

        <input
          type="text"
          placeholder="External Article Link"
          value={newNews.url || ""}
          onChange={(e) => setNewNews({ ...newNews, url: e.target.value })}
          className="border p-2 w-full mb-2"
        />

        <button
          onClick={handleCreate}
          className="bg-green-500 text-white px-4 py-2 rounded"
        >
          Add News
        </button>
      </div>

      {/* Add Video */}
      <div className="mb-6 p-4 border rounded shadow-md">
        <h2 className="text-xl font-semibold mb-4">Add Book News Video</h2>

        <input
          type="text"
          placeholder="Video Title"
          value={newVideo.title || ""}
          onChange={(e) => setNewVideo({ ...newVideo, title: e.target.value })}
          className="border p-2 w-full mb-2"
        />

        <div className="mb-2">
          <label className="mr-4">
            <input
              type="radio"
              name="videoType"
              checked={newVideo.isExternal}
              onChange={() =>
                setNewVideo({
                  ...newVideo,
                  isExternal: true,
                  file: null,
                })
              }
            />{" "}
            Use Video URL
          </label>

          <label>
            <input
              type="radio"
              name="videoType"
              checked={!newVideo.isExternal}
              onChange={() =>
                setNewVideo({
                  ...newVideo,
                  isExternal: false,
                  url: "",
                })
              }
            />{" "}
            Upload Video
          </label>
        </div>

        {newVideo.isExternal ? (
          <input
            type="text"
            placeholder="Video URL"
            value={newVideo.url || ""}
            onChange={(e) => setNewVideo({ ...newVideo, url: e.target.value })}
            className="border p-2 w-full mb-2"
          />
        ) : (
          <input
            type="file"
            accept="video/*"
            onChange={(e) =>
              setNewVideo({ ...newVideo, file: e.target.files[0] })
            }
            className="border p-2 w-full mb-2"
          />
        )}

        <button
          onClick={handleCreateVideo}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Add Video
        </button>
      </div>

      {/* Display News Items */}
      {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {newsItems.map((news) => (
          <div key={news._id} className="border p-4 rounded shadow-md">
            <img
              src={getImageSrc(news.imageUrl)}
              alt={news.title}
              className="w-full h-40 object-cover rounded"
              onError={(e) => {
                console.log("IMAGE FAILED TO LOAD:", e.currentTarget.src);
                e.currentTarget.onerror = null;
                e.currentTarget.src = "/default-placeholder.png";
              }}
            />

            <h3 className="text-lg font-semibold mt-2">{news.title}</h3>

            <a
              href={news.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline block mt-2"
            >
              View Article
            </a>

            <button
              // onClick={() => handleDelete(news._id)}
              onClick={() => handleDelete(item)}
              className="bg-red-500 text-white px-2 py-1 rounded mt-3"
            >
              Delete
            </button>
          </div>
        ))}
      </div> */}
      {/* Display News Items */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {newsItems.map((item) => (
          <div key={item._id} className="border p-4 rounded shadow-md">
            {item.itemType === "video" ? (
              item.fileUrl ? (
                <video className="w-full h-40 object-cover rounded" controls>
                  <source src={getVideoSrc(item)} type="video/mp4" />
                </video>
              ) : (
                <iframe
                  className="w-full h-40 rounded"
                  src={getVideoSrc(item)}
                  title={item.title}
                  allowFullScreen
                />
              )
            ) : (
              <img
                src={getImageSrc(item.imageUrl)}
                alt={item.title}
                className="w-full h-40 object-cover rounded"
                onError={(e) => {
                  console.log("IMAGE FAILED TO LOAD:", e.currentTarget.src);
                  e.currentTarget.onerror = null;
                  // e.currentTarget.src = "/default-placeholder.png";
                  e.currentTarget.src = "https://placehold.co/600x400.png";
                }}
              />
            )}

            <h3 className="text-lg font-semibold mt-2">{item.title}</h3>

            {item.itemType === "link" && (
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:underline block mt-2"
              >
                View Article
              </a>
            )}

            {item.itemType === "video" && (
              <p className="text-sm text-gray-500 mt-2">Video</p>
            )}

            <button
              onClick={() => handleDelete(item)}
              className="bg-red-500 text-white px-2 py-1 rounded mt-3"
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminBooksNews;

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { getLinks, createLink, deleteLink } from "../../api/linkApi";
// import { uploadImage } from "../../api/imageApi";

// const AdminBooksNews = () => {
//   const [newsItems, setNewsItems] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [newNews, setNewNews] = useState({
//     title: "",
//     url: "",
//     image: "",
//     file: null,
//     isExternal: true,
//   });

//   const category = "Books News";
//   const navigate = useNavigate();

//   const getImageSrc = (imageUrl) => {
//   if (!imageUrl) return "/default-placeholder.png";

//   if (imageUrl.startsWith("http")) {
//     return imageUrl;
//   }

//   const serverUrl = process.env.REACT_APP_API_URL.replace("/api", "");
//   const cleanImageUrl = imageUrl.startsWith("/") ? imageUrl : `/${imageUrl}`;

//   return `${serverUrl}${cleanImageUrl}`;
// };

//   useEffect(() => {
//     const fetchNews = async () => {
//       try {
//         const links = await getLinks(category);

//         const sortedLinks = links.sort(
//           (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
//         );

//         setNewsItems([...sortedLinks]);
//       } catch (error) {
//         console.error("Error fetching book news:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchNews();
//   }, []);

//   const handleCreate = async () => {
//     if (!newNews.title || !newNews.url || (!newNews.image && !newNews.file)) {
//       alert("Please add a title, external link, and image.");
//       return;
//     }

//     try {
//       let imageUrl = newNews.image;

//       if (newNews.file) {
//         const formData = new FormData();
//         formData.append("image", newNews.file);
//         formData.append("title", newNews.title);
//         formData.append("category", category);

//         const uploadedImage = await uploadImage(formData, category);
// console.log("Uploaded image response:", uploadedImage);

// imageUrl = uploadedImage.fileUrl;
// console.log("Final imageUrl being saved:", imageUrl);
//       }

//       const data = {
//         title: newNews.title,
//         url: newNews.url,
//         imageUrl,
//         category,
//       };

//       console.log("Books News link data being sent:", data);

// const createdItem = await createLink(data);
// console.log("Created Books News item:", createdItem);

//       const updatedNews = [createdItem, ...newsItems];

//       const sortedNews = updatedNews.sort(
//         (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
//       );

//       // Important: no slice and no delete.
//       // Books News keeps all articles.
//       setNewsItems(sortedNews);

//       setNewNews({
//         title: "",
//         url: "",
//         image: "",
//         file: null,
//         isExternal: true,
//       });
//     } catch (error) {
//       console.error("Error adding book news:", error);
//     }
//   };

//   const handleDelete = async (id) => {
//     try {
//       await deleteLink(id);
//       setNewsItems(newsItems.filter((item) => item._id !== id));
//     } catch (error) {
//       console.error("Error deleting book news:", error);
//     }
//   };

//   if (loading) return <p className="p-6">Loading...</p>;

//   return (
//     <div className="container mx-auto p-6">
//       <button
//         onClick={() => navigate("/admin")}
//         className="bg-gray-300 text-gray-800 px-4 py-2 rounded mb-4 hover:bg-gray-400"
//       >
//         ← Back to Dashboard
//       </button>

//       <h1 className="text-3xl font-bold mb-6">Admin - Books News</h1>

//       {/* Add News */}
//       <div className="mb-6 p-4 border rounded shadow-md">
//         <h2 className="text-xl font-semibold mb-4">Add Book News Item</h2>

//         <input
//           type="text"
//           placeholder="Title"
//           value={newNews.title}
//           onChange={(e) =>
//             setNewNews({ ...newNews, title: e.target.value })
//           }
//           className="border p-2 w-full mb-2"
//         />

//         <div className="mb-2">
//           <label className="mr-4">
//             <input
//               type="radio"
//               name="imageType"
//               checked={newNews.isExternal}
//               onChange={() =>
//                 setNewNews({
//                   ...newNews,
//                   isExternal: true,
//                   file: null,
//                 })
//               }
//             />{" "}
//             Use Image URL
//           </label>

//           <label>
//             <input
//               type="radio"
//               name="imageType"
//               checked={!newNews.isExternal}
//               onChange={() =>
//                 setNewNews({
//                   ...newNews,
//                   isExternal: false,
//                   image: "",
//                 })
//               }
//             />{" "}
//             Upload Image
//           </label>
//         </div>

//         {newNews.isExternal ? (
//           <input
//             type="text"
//             placeholder="Image URL"
//             value={newNews.image}
//             onChange={(e) =>
//               setNewNews({ ...newNews, image: e.target.value })
//             }
//             className="border p-2 w-full mb-2"
//           />
//         ) : (
//           <input
//             type="file"
//             accept="image/*"
//             onChange={(e) =>
//               setNewNews({ ...newNews, file: e.target.files[0] })
//             }
//             className="border p-2 w-full mb-2"
//           />
//         )}

//         <input
//           type="text"
//           placeholder="External Article Link"
//           value={newNews.url}
//           onChange={(e) =>
//             setNewNews({ ...newNews, url: e.target.value })
//           }
//           className="border p-2 w-full mb-2"
//         />

//         <button
//           onClick={handleCreate}
//           className="bg-green-500 text-white px-4 py-2 rounded"
//         >
//           Add News
//         </button>
//       </div>

//       {/* Display News Items */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//         {newsItems.map((news) => (
//           <div key={news._id} className="border p-4 rounded shadow-md">
//             <img
//   src={getImageSrc(news.imageUrl)}
//   alt={news.title}
//   className="w-full h-40 object-cover rounded"
//   onError={(e) => {
//     e.currentTarget.onerror = null;
//     e.currentTarget.src = "/default-placeholder.png";
//   }}
// />

//             <h3 className="text-lg font-semibold mt-2">{news.title}</h3>

//             <a
//               href={news.url}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="text-blue-500 hover:underline block mt-2"
//             >
//               View Article
//             </a>

//             <button
//               onClick={() => handleDelete(news._id)}
//               className="bg-red-500 text-white px-2 py-1 rounded mt-3"
//             >
//               Delete
//             </button>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default AdminBooksNews;
